import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import { useExchangeTokenMutation } from '../../features/auth/authApi';
import { setCredentials } from '../../features/auth/authSlice';

const AuthHandoffPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [exchangeToken, { error }] = useExchangeTokenMutation();

  useEffect(() => {
    const accessToken = searchParams.get('accessToken');
    const refreshToken = searchParams.get('refreshToken');

    console.log('AuthHandoff: Tokens from URL:', { 
      hasAccessToken: !!accessToken, 
      hasRefreshToken: !!refreshToken 
    });

    if (!accessToken || !refreshToken) {
      console.error('AuthHandoff: Missing tokens in URL');
      navigate('/login', { replace: true });
      return;
    }

    const performExchange = async () => {
      try {
        const response = await exchangeToken({ accessToken, refreshToken }).unwrap();
        
        if (response.success) {
          dispatch(
            setCredentials({
              user: response.data.user,
              accessToken: response.data.tokens.access.token,
              refreshToken: response.data.tokens.refresh.token,
            })
          );
          // Redirect to editor if templateId is present, otherwise home
          const templateId = searchParams.get('templateId');
          if (templateId) {
            navigate(`/template-editor?id=${templateId}&isCmsId=true`, { replace: true });
          } else {
            navigate('/home', { replace: true });
          }
        } else {
          navigate('/login', { replace: true });
        }
      } catch (err) {
        navigate('/login', { replace: true });
      }
    };

    performExchange();
  }, [searchParams, exchangeToken, dispatch, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="p-8 bg-white dark:bg-gray-800 rounded-xl shadow-lg text-center max-w-md w-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Verifying Session
        </h2>
        <p className="text-gray-600 dark:text-gray-400">
          Please wait while we set up your secure session...
        </p>
        {error && (
          <p className="mt-4 text-red-500 text-sm">
            Something went wrong. Redirecting to login...
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthHandoffPage;
